<template>
  <TheHeader></TheHeader>
  <router-view/>
  <TheFooter></TheFooter>
</template>
<script setup>
  import TheHeader from './components/TheHeader.vue'
  import TheFooter from './components/TheFooter.vue'
</script>


<style lang="scss">
  @import "./styles/_variables.scss";
  @import "./styles/_styles.scss";

  .header {
    position: sticky;
    top: 0;
    background-color: var(--primary-background-color);
    z-index: 1000;

    .container {
      display: flex;
      justify-content: space-between;
    }
  }

  .menu-items {
    display: flex;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    
    a {
      text-decoration: none;
      color: var(--font-color);
    }
  }
</style>
